var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroductionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.282 8.273c.506.226.773.643.773 1.087 0 .445-.267.855-.773 1.087l-6.665 3.049c-.731.335-1.333.485-1.914.479-.58.006-1.182-.137-1.914-.48L6.795 12.13l4.197-1.942c.226.069.479.103.732.103.806 0 1.586-.383 1.586-.93 0-.54-.78-.916-1.586-.916-.814 0-1.593.376-1.593.916 0 .041.007.082.034.13L5.66 11.582l-2.536-1.135c-.506-.225-.772-.642-.772-1.087 0-.444.266-.861.772-1.087l6.665-3.049c.732-.328 1.333-.485 1.914-.471.581-.014 1.183.143 1.914.471l6.665 3.05zM6.774 13.27l2.584 1.176c.848.39 1.62.581 2.345.574.725.007 1.504-.184 2.345-.574l4.505-2.064v2.037c0 2.18-2.844 3.917-6.85 3.917-2.003 0-3.712-.43-4.929-1.155v-3.91zm-1.92-.881.833.382v3.514c-.54-.588-.833-1.271-.833-1.866v-2.03zm.19 6.405c0-.479.247-.82.644-.95v-1.559c.28.335.649.636 1.086.895v.664c.397.13.636.478.636.95v1.757c0 .615-.403 1.011-1.012 1.011h-.341c-.609 0-1.012-.396-1.012-1.011v-1.757z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroductionIcon);
export default __webpack_public_path__ + "static/media/introductionIcon.87ede7eea8ec057158ba2904a15f4bd8.svg";
export { ForwardRef as ReactComponent };